// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"LogoBanner_headerContainer__atROD","headerImage":"LogoBanner_headerImage__3BsPq"};